import { httpClient } from "utils";
import { InterExtrapolateRequestBody } from "./types";
import { INTEREXTRAPOLATE_API_PATHS } from "./consts";


export const postMissingDocuments = (missingDocumentsRequest: any) =>
  httpClient.post<any>('/aggregations/missing', missingDocumentsRequest);

export const interExtrapolateFillGaps = (body: InterExtrapolateRequestBody) =>
  httpClient.post(INTEREXTRAPOLATE_API_PATHS.FILL_GAPS, body);

export const interExtrapolateRefresh = (body: InterExtrapolateRequestBody) =>
  httpClient.post(INTEREXTRAPOLATE_API_PATHS.REFRESH_EXTRAPOLATION, body);